import { useState, useEffect } from "react";
import { FaArrowCircleUp } from "react-icons/fa";

const ScrollToTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  return (
    <div className="fixed bottom-28 right-12 z-50">
      {showTopBtn ? (
        <button onClick={scrollToTop} className="my-scroll-to-top">
          <FaArrowCircleUp size={42} />
        </button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ScrollToTop;
